import React from "react";
import { CV } from "../components/cv";
import ViktorNImg from "@/assets/images/viktor-n.png";

export default function CVViktorNilsson() {
  React.useEffect(() => {
    document.title = "BoldBrave CV - Viktor Nilsson";
  }, []);

  return (
    <CV
      name="Viktor Nilsson"
      title="Frontend & App Developer"
      subtitle="React and TypeScript frontend specialist — background at tretton37 and Cybercom Group"
      photo={ViktorNImg}
      summary="Positive, problem-solving developer with 11 years in the industry — starting out in iOS development before moving into frontend, where he has spent most of his career. Believes good communication and well-functioning teams are the foundation for great applications, and is passionate about automating things and building performant, responsive interfaces with great attention to detail. Works primarily with React, TypeScript, Next.js and React Native/Expo as a freelance consultant, and embraces agentic development workflows with tools like Claude and Codex."
      skills={{
        "Languages": ["JavaScript", "TypeScript", "Swift", "Objective-C"],
        "Frontend": ["React", "Redux", "Next.js", "Emotion", "SASS/SCSS", "CSS", "HTML"],
        "Mobile": ["React Native", "Expo", "iOS Native"],
        "Backend & API": ["Node.js", "GraphQL"],
        "Cloud & Tooling": ["Azure", "AWS", "Webpack", "Storybook", "Figma", "Git"],
        "AI Tooling": ["Claude", "Codex", "Agentic Development"],
        "Methods": ["Responsive Design", "Web Performance", "Frontend Development"],
      }}
      experience={[
        {
          role: "Frontend & App Developer",
          company: "BoldBrave · Freelance · Malmö, Skåne County, Sweden",
          period: "2021 – Present",
          description:
            "Freelance frontend and app developer building modern web and mobile applications with React, TypeScript and React Native.",
          highlights: [
            "Fitness24Seven (2023 – Present) — Senior Frontend and App Developer working across the digital platform: the customer-facing app and website, internal admin tools and parts of the backend; part of rolling out a new entrance system (React, TypeScript, Next.js, Expo, React Native, Node.js, GraphQL, Azure)",
            "Kjell & Company (2021 – 2023) — Senior Frontend Developer improving and extending the kjell.com e-commerce platform with new customer-facing features, bringing domain knowledge from previously working in their stores (React, Redux, TypeScript, EPiServer, .NET, C#)",
          ],
        },
        {
          role: "Freelance Frontend Developer",
          company: "VNIL · Self-employed · Furulund",
          period: "Dec 2020 – Present",
          description:
            "Own consulting company through which Viktor takes on frontend and app assignments.",
        },
        {
          role: "Frontend Developer",
          company: "tretton37 AB · Lund",
          period: "Jan 2018 – Feb 2021",
          description:
            "Frontend development at a consultancy known for high technical standards and quality-driven delivery.",
          highlights: [
            "Global Dialysis Company (2019 – 2021) — web application nurses use during dialysis treatments, entering values directly on a tablet and reading from the machine when possible to speed things up and reduce human error (React, Redux Toolkit, TypeScript, Emotion, Storybook)",
            "Modelling Software Company (2018 – 2019) — browser-based application for building and simulating complex systems, normally done in desktop software (React, TypeScript, Canvas, THREE.js)",
            "Major German transportation company (2018) — early-stage iOS app unifying Germany's transport apps with timetables and automatic ticket purchasing (Swift, RxSwift)",
            "International Shipping & Logistics Company (2018) — brand new website on the headless CMS Contentful, hosted on AWS, with reusable components for content creators (React, Redux, Contentful, AWS, Node, Lambda)",
          ],
        },
        {
          role: "Frontend Developer",
          company: "Avalon Innovation · Malmö",
          period: "Jan 2017 – Jan 2018",
          description:
            "Frontend development in a consulting environment focused on innovation and product development.",
          highlights: [
            "Recycling Service (2017) — frontend lead in a small team building a platform to move a recycling company off Excel and onto a more sophisticated web application for managing clients, relationships and invoices (React, Redux, SASS)",
          ],
        },
        {
          role: "Frontend & iOS Developer",
          company: "Cybercom Group · Malmö",
          period: "Sep 2014 – Dec 2016",
          description:
            "Frontend and native iOS development, building web and mobile applications for a range of clients.",
          highlights: [
            "Global Furniture Company (2015 – 2016) — sofa configurator built with a team of five frontend developers, including low-level 3D handling (Angular, Pixi.js, JavaScript, LESS)",
            "Facility System Provider (2015) — advanced entry phone system integrated with a visitor management system (Angular, JavaScript, LESS)",
            "Swedish Cinema Company (2014 – 2015) — iOS work refactoring and extending SF Bio's app, plus an accessibility framework that syncs audio descriptions to a movie's sound so blind cinema-goers can follow along (Xcode, Swift, Objective-C, Audible Magic)",
          ],
        },
        {
          role: "Sales Associate",
          company: "Kjell & Company · Lund",
          period: "Nov 2011 – Sep 2014",
          description:
            "Retail sales of consumer electronics and accessories, advising customers on tech products.",
        },
      ]}
      education={[
        {
          degree: "Exchange Program, Japanese",
          institution: "Waseda University, Tokyo",
          year: "2010 – 2011",
        },
        {
          degree: "Bachelor's Degree, Japanese",
          institution: "Lund University",
          year: "2006 – 2010",
        },
      ]}
    />
  );
}
